<script setup lang="ts">
definePageMeta({
  layout: 'home',
  auth: false
})

const auth = useAuth();
const router = useRouter();

if (auth.loggedIn && process.client) {
  const redirectPath = localStorage.getItem("auth.redirect");

  if (redirectPath) {
    localStorage.removeItem("auth.redirect");
    router.push(redirectPath);
  }
}
</script>

<template>
  <div class="relative overflow-hidden">

  </div>
</template>
